





import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";


// Async Thunks

// Fetch Available Days
export const fetchAvailableDays = createAsyncThunk(
  "calender/fetchAvailableDays",
  async (_, thunkApi) => {
    const { rejectWithValue } = thunkApi;
    try {
      const res = await fetch("https://ssl.vipwellness-suite.de/api/orders/available-days", {
        headers: {
          Authorization: `Bearer ${sessionStorage.getItem("token")}`,
        },
      });
      const data = await res.json();
      return data;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);



// Initial State
const initialState = {
  calender: [],
  numberOfCalender: 0,
  getLoading: false,
  availableDays: [],
  createLoading: false,
  error: null,
  records: [],
  Loading: false,
  erorr: null,
  reco: [],
};

// Create Slice
const combinedSlice = createSlice({
  name: "combined",
  initialState: initialState,
  reducers: {
    setCalender(state, action) {
      state.calender = action.payload;
    },
    setNumberOfCalender(state, action) {
      state.numberOfCalender = action.payload;
    },
    setGetLoading(state, action) {
      state.getLoading = action.payload;
    },
    setCreateLoading(state, action) {
      state.createLoading = action.payload;
    },
  },
  extraReducers: (builder) => {
    // Fetch Available Days
    builder.addCase(fetchAvailableDays.pending, (state) => {
      state.getLoading = true;
      state.error = null;
    });
    builder.addCase(fetchAvailableDays.fulfilled, (state, action) => {
      state.getLoading = false;
      state.availableDays = action.payload;
    });
    builder.addCase(fetchAvailableDays.rejected, (state, action) => {
      state.getLoading = false;
      state.error = action.payload;
    });

    
  },
});

// Export Reducer and Actions
export const { setCalender, setNumberOfCalender, setGetLoading, setCreateLoading } = combinedSlice.actions;
export default combinedSlice.reducer;
